import React from 'react'

import IconArrowDown from 'client/icons/ChevronDown'
import IconArrowUp from 'client/icons/ChevronUp'
import { useIntl } from 'react-intl'
import Button from 'src/comps/Atom/Buttons/Button'

const RoomOptionsToggle = ({
  isOpen,
  onClick,
  options,
  outlinedShowMoreButton,
}: {
  isOpen: boolean
  onClick: () => void
  options: number
  outlinedShowMoreButton?: boolean
}) => {
  const intl = useIntl()

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault()
    onClick()
  }

  return (
    <Button
      data-testid="button-room-options"
      rounded
      outlined={outlinedShowMoreButton}
      filledLight={!outlinedShowMoreButton}
      size="m"
      type="button"
      onClick={handleClick}
    >
      {isOpen ? (
        <>
          <span>{intl.formatMessage({ id: 'global.view-less' })}</span>
          <IconArrowUp size={16} />
        </>
      ) : (
        <>
          <span>{intl.formatMessage({ id: 'global.see-options' }, { options })}</span>
          <IconArrowDown size={16} />
        </>
      )}
    </Button>
  )
}

export default RoomOptionsToggle
